import { useQuery } from '@tanstack/react-query';
import { listQuickReplies } from '../../api';
import { quickRepliesKey } from './keys';

/** Uma resposta nova aparece para a equipe em até 1 minuto (docs/quick-replies.md). */
export const QUICK_REPLIES_STALE_MS = 60_000;

export function useQuickReplies() {
  return useQuery({
    queryKey: quickRepliesKey,
    queryFn: ({ signal }) => listQuickReplies(signal),
    staleTime: QUICK_REPLIES_STALE_MS,
  });
}
